module.exports = __webpack_public_path__ + "img/icon_cat_modbus.7130491.png";